"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeSelect = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var i18n_1 = require("../i18n");
var form_1 = require("../form");
var config_context_1 = require("../_util/config-context");
var warn_1 = require("../_util/warn");
function groupBy(options) {
    var groups = [];
    options.forEach(function (opt, index) {
        var groupKey = opt.groupKey;
        if (index === 0 || groupKey !== options[index - 1].groupKey) {
            groups.push([]);
        }
        groups[groups.length - 1].push(opt);
    });
    return groups;
}
/**
 * 原生 Select
 */
exports.NativeSelect = react_1.default.forwardRef(function (props, ref) {
    var _a;
    var t = (0, i18n_1.useTranslation)();
    var classPrefix = (0, config_context_1.useConfig)().classPrefix;
    var _b = (0, form_1.useDefaultValue)(props, null), type = _b.type, value = _b.value, onChange = _b.onChange, _c = _b.options, options = _c === void 0 ? [] : _c, _d = _b.groups, groups = _d === void 0 ? {} : _d, _e = _b.placeholder, placeholder = _e === void 0 ? t.pleaseSelect : _e, disabled = _b.disabled, size = _b.size, className = _b.className, extraProps = (0, tslib_1.__rest)(_b, ["type", "value", "onChange", "options", "groups", "placeholder", "disabled", "size", "className"]);
    (0, react_1.useEffect)(function () {
        (0, warn_1.warn)('"native" 类型 Select 将在下个 minor 版本中统一转换为模拟下拉形式，建议预先修改并验证');
    }, []);
    return (react_1.default.createElement("select", (0, tslib_1.__assign)({ ref: ref, className: (0, classnames_1.default)(classPrefix + "-select", className, (_a = {},
            _a["size-" + (size === 'full' || size === 'auto' ? size + "-width" : size)] = size,
            _a)), disabled: disabled, 
        // eslint-disable-next-line eqeqeq
        value: value != null ? value : '', placeholder: placeholder, onChange: disabled
            ? null
            : function (event) {
                var value = event.target.value;
                onChange(value, {
                    event: event,
                    option: options.find(function (i) { return i.value === value; }),
                });
            } }, extraProps),
        typeof placeholder === 'string' && (react_1.default.createElement("option", { disabled: !!value, hidden: true }, placeholder)),
        options.find(function (opt) { return !!opt.groupKey; })
            ? groupBy(options).map(function (group) {
                var _a = group[0], value = _a.value, groupKey = _a.groupKey;
                if (!groupKey) {
                    return group.map(function (opt) { return (react_1.default.createElement("option", { key: opt.value, value: opt.value, disabled: opt.disabled, title: typeof opt.tooltip === 'string' ? opt.tooltip : undefined }, typeof opt.text === 'undefined' ? opt.value : opt.text)); });
                }
                return (react_1.default.createElement("optgroup", { key: value, label: groups[groupKey] || '' }, group.map(function (opt) { return (react_1.default.createElement("option", { key: opt.value, value: opt.value, disabled: opt.disabled, title: typeof opt.tooltip === 'string' ? opt.tooltip : undefined }, typeof opt.text === 'undefined' ? opt.value : opt.text)); })));
            })
            : options.map(function (opt) { return (react_1.default.createElement("option", { key: opt.value, value: opt.value, disabled: opt.disabled, title: typeof opt.tooltip === 'string' ? opt.tooltip : undefined }, typeof opt.text === 'undefined' ? opt.value : opt.text)); })));
});
exports.NativeSelect.displayName = 'NativeSelect';
